module.exports = __webpack_public_path__ + "img/title-2.6f8815a3.png";